import Multitracker from 'js/app/multitrackerSingleton';
import { randomUUID } from 'js/lib/uuid';

import sessionStorage from 'bundles/common/utils/sessionStorageEx';

import { SESSION_STORAGE_KEY } from './constants';
import type { HeartbeatPayload } from './useHeartbeatPayload';

const EVENT_NAMESPACE = 'lms';
const EVENT_PAGE = 'heartbeat';
const EVENT_ACTION = 'beat';
export const EVENT_FULL_KEY = `${EVENT_NAMESPACE}.${EVENT_PAGE}.${EVENT_ACTION}`;

export interface HeartbeatMultitrackerPayload extends HeartbeatPayload {
  heartbeatCount: number;
}

/** No-op serialization / deserialization */
const noOpConverter = (s: string) => s;
/** Fetch or generate and save a unique identifier for this browser tab or window to assist in deduplication */
export const browserTabOrWindowUniqueIdentifier = () => {
  const tabGuidFromStorage = sessionStorage.getItem<string | undefined>(SESSION_STORAGE_KEY, noOpConverter, undefined);
  if (tabGuidFromStorage) {
    return tabGuidFromStorage;
  }

  const newUUID = randomUUID();
  sessionStorage.setItem(SESSION_STORAGE_KEY, newUUID, noOpConverter);
  return newUUID;
};

/**
 * The final value of the heartbeat before it's pushed into the eventing system.
 * Includes everything required to make the eventing system accept our event.
 */
export interface FinalHeartbeatPayload extends HeartbeatMultitrackerPayload {
  /** Unique browser tab / window identifier */
  browserWindowId: string;
  namespace: {
    app: string;
    page: string;
    action: string;
  };
  // eslint-disable-next-line camelcase
  schema_type: 'FRONTEND';
}

export const makeNetworkCall = (payload: HeartbeatMultitrackerPayload) => {
  const finalPayload: FinalHeartbeatPayload = {
    ...payload,
    browserWindowId: browserTabOrWindowUniqueIdentifier(),
    namespace: {
      app: EVENT_NAMESPACE,
      page: EVENT_PAGE,
      action: EVENT_ACTION,
    },
    // eslint-disable-next-line camelcase
    schema_type: 'FRONTEND',
  };
  Multitracker.pushV2([EVENT_FULL_KEY, finalPayload]);
};
